module.exports = __webpack_public_path__ + "fonts/Montserrat-VariableFont_wght.08627726.ttf";